<template>
  <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <rect width="32" height="32" id="artboard_1" />
      <clipPath id="clip_1">
        <use xlink:href="#artboard_1" clip-rule="evenodd" />
      </clipPath>
    </defs>
    <g id="iconCheck" clip-path="url(#clip_1)">
      <path d="M24.9393 7.93934C25.5251 7.35355 26.4749 7.35355 27.0607 7.93934C27.6098 8.48851 27.6442 9.35758 27.1636 9.94674L27.0607 10.0607L13.0607 24.0607C12.5115 24.6098 11.6424 24.6442 11.0533 24.1636L10.9393 24.0607L4.93934 18.0607C4.35355 17.4749 4.35355 16.5251 4.93934 15.9393C5.48851 15.3902 6.35758 15.3558 6.94674 15.8364L7.06066 15.9393L12 20.879L24.9393 7.93934Z" id="Check" fill="#555553" stroke="none" artboard="9b30a5b1-6fa7-448c-98b3-0a51dd324811" />
    </g>
  </svg>
</template>
